module.exports = __webpack_public_path__ + "static/img/1.f641652.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/eng/1.png
// module id = ig9k
// module chunks = 0